<template>
  <div>
    <div class="row border-bottom pb-3 mx-0">
      <div class="col-md-6 d-flex align-items-center">
        <span class="fa-stack fa-1x font-15 ml-n3">
          <em class="fas fa-circle fa-stack-2x color-white"></em>
          <em class="fa-stack-1x fas fa-file-alt color-orange-light-2" />
        </span>
        <span class="color-black-1 font-20 font-weight-bold ml-2">
          {{ $t('LnkCircularLetter') }}
        </span>
      </div>
      <div class="col-md-6 text-right pt-4 pt-md-0">
        <a
          class="btn-warning px-4 rounded p-3 text-decoration-none cursor-pointer"
          i="fa fa-download"
          href="/carta-circular.pdf"
          target="_blank"
        >
          <em class="fa fa-download mr-2" />
          <span>{{ $t('DownloadCircularLetter') }}</span>
        </a>
      </div>
    </div>
    <div class="mt-3">
      <div class="bg-gray-21 rounded py-3">
        <div class="text-container px-4">
          <iframe
            title="Carta Circular"
            src="/carta-circular.pdf#toolbar=0&navpanes=0&scrollbar=0"
            frameborder="0"
            width="100%"
            height="100%"
          ></iframe>
        </div>
      </div>
      <validation-observer ref="formRef" v-slot="{}" tag="form">
        <div class="read-container">
          <b-form-checkbox
            id="chkCircularLetter"
            v-model="model.read"
            :unchecked-value="false"
          >
            <span>{{ $t('IHaveReadCircularLetterTerms') }}.</span>
          </b-form-checkbox>
        </div>
        <validation-provider
          :rules="{ required_if: !model.read }"
          v-slot="{ errors }"
        >
          <custom-error
            v-if="errors[0]"
            class="no-border mt-2"
            :message="`${$t('YouMustAceptTermsAndCondition')}`"
          />
        </validation-provider>
      </validation-observer>
    </div>
  </div>
</template>

<script>
//libs
import CustomError from 'custom-error';

export default {
  name: 'CircularLetter',
  components: {
    CustomError,
  },
  data: () => ({
    model: {
      read: null,
    },
  }),
  methods: {
    getModel() {
      return { ...this.model };
    },
    setModel(value) {
      this.model = {
        ...this.model,
        ...value,
      };
    },
    async validate() {
      return await this.$refs.formRef.validate();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';
@import '@/scss/bootstrap/_colors.scss';

.text-container {
  height: 700px;
}
.read-container {
  padding: 20px;
  background: map-get($colors, 'yellow-star-4') 0% 0% no-repeat padding-box;
  border: 2px solid map-get($colors, 'orange-light-2');
  border-radius: 0px 0px 4px 4px;
  color: map-get($colors, 'white');
}
</style>
